module.exports = __webpack_public_path__ + "img/core-values-1.3355bd8a.svg";